'use strict';
import * as $i_$0040ui5$002fwebcomponents$002fdist$002fOption$002ejs from "@ui5/webcomponents/dist/Option.js";
import * as $j_be$002edoeraene$002ewebcomponents$002e$002dWeb$002dComponent from "./be.doeraene.webcomponents.-Web-Component.js";
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024 from "./com.raquo.laminar.codecs.package$.js";
import * as $j_com$002eraquo$002elaminar$002etags$002e$002dCustom$002dHtml$002dTag$0024 from "./com.raquo.laminar.tags.-Custom-Html-Tag$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lbe_doeraene_webcomponents_ui5_SelectOption$() {
  this.Dg = null;
  this.De = null;
  this.Df = false;
  $n_Lbe_doeraene_webcomponents_ui5_SelectOption$ = this;
  $j_be$002edoeraene$002ewebcomponents$002e$002dWeb$002dComponent.$f_Lbe_doeraene_webcomponents_WebComponent__$init$__V(this);
  $i_$0040ui5$002fwebcomponents$002fdist$002fOption$002ejs.default;
  this.Dg = new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_tags_CustomHtmlTag("ui5-option", $j_com$002eraquo$002elaminar$002etags$002e$002dCustom$002dHtml$002dTag$0024.$m_Lcom_raquo_laminar_tags_CustomHtmlTag$().eO(), ($j_com$002eraquo$002elaminar$002etags$002e$002dCustom$002dHtml$002dTag$0024.$m_Lcom_raquo_laminar_tags_CustomHtmlTag$(), (void 0)));
}
export { $c_Lbe_doeraene_webcomponents_ui5_SelectOption$ as $c_Lbe_doeraene_webcomponents_ui5_SelectOption$ };
$p = $c_Lbe_doeraene_webcomponents_ui5_SelectOption$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lbe_doeraene_webcomponents_ui5_SelectOption$;
/** @constructor */
function $h_Lbe_doeraene_webcomponents_ui5_SelectOption$() {
}
export { $h_Lbe_doeraene_webcomponents_ui5_SelectOption$ as $h_Lbe_doeraene_webcomponents_ui5_SelectOption$ };
$h_Lbe_doeraene_webcomponents_ui5_SelectOption$.prototype = $p;
$p.fP = (function(x$0) {
});
$p.ec = (function() {
  return this.Dg;
});
$p.uB = (function() {
  if ((!this.Df)) {
    this.De = ($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$(), $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$ct_Lcom_raquo_laminar_keys_HtmlAttr__T__Lcom_raquo_laminar_codecs_Codec__(new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_keys_HtmlAttr(), "selected", $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024.$m_Lcom_raquo_laminar_codecs_package$().gN));
    this.Df = true;
  }
  return this.De;
});
var $d_Lbe_doeraene_webcomponents_ui5_SelectOption$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lbe_doeraene_webcomponents_ui5_SelectOption$, "be.doeraene.webcomponents.ui5.SelectOption$", ({
  gn: 1,
  ar: 1,
  bk: 1,
  gg: 1,
  bG: 1
}));
export { $d_Lbe_doeraene_webcomponents_ui5_SelectOption$ as $d_Lbe_doeraene_webcomponents_ui5_SelectOption$ };
var $n_Lbe_doeraene_webcomponents_ui5_SelectOption$;
function $m_Lbe_doeraene_webcomponents_ui5_SelectOption$() {
  if ((!$n_Lbe_doeraene_webcomponents_ui5_SelectOption$)) {
    $n_Lbe_doeraene_webcomponents_ui5_SelectOption$ = new $c_Lbe_doeraene_webcomponents_ui5_SelectOption$();
  }
  return $n_Lbe_doeraene_webcomponents_ui5_SelectOption$;
}
export { $m_Lbe_doeraene_webcomponents_ui5_SelectOption$ as $m_Lbe_doeraene_webcomponents_ui5_SelectOption$ };
